import { createFileRoute } from '@tanstack/react-router';
import { useSampleSet } from '../../../../../../contexts/SampleSetContext';
import ReportsTab from '../../../../../../pages/experiments/ReportsTab';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/reports/'
)({
  component: ReportsListRoute,
});

function ReportsListRoute() {
  const { sampleSet } = useSampleSet();

  if (!sampleSet) {
    return null;
  }

  return <ReportsTab sampleSetId={sampleSet.id} />;
}
